import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WarningDialogComponent } from 'src/app/shared/dialogs/warning-dialog/warning-dialog.component';

@Component({
  selector: 'app-layout-register-client',
  templateUrl: './layout-register-client.component.html',
  styleUrls: ['./layout-register-client.component.scss'],
})
export class LayoutRegisterClientComponent implements OnInit {
  currentStep: number;

  constructor(private dialog: MatDialog) {
    this.currentStep = 1;
    this.dialog.open(WarningDialogComponent, {
      width: '60%',
      disableClose: true,
      data: {
        title:
          'Se reprovado enviaremos um comunicado por e-mail.',
        message: [
          'Será solicitado o envio de dados cadastrais e alguns documentos, sendo estes:',
          'Contrato Social, Requerimento de Empresário ou Certificado de MEI.',
          'Cópia RG e CPF. (frente e verso),',
          'Comprovante de endereço residencial mais recente.',
          'É necessário que os documentos estejam regulares nos órgãos competentes (endereço e situação cadastral).',
          '  ',
          '  ',
          'Após o recebimento e análise das informações o prazo para conclusão do cadastro é de até 7 dias úteis.',
          'Sendo aprovado o representante entrará em contato.',
          'Se para negado enviaremos um comunicado por e-mail',
        ],
      },
    });
  }

  ngOnInit(): void {}

  backForm() {
    this.currentStep--;
  }

  changeForm(event: number) {
    this.currentStep = event;
  }
}
